import React, { useEffect, useRef, useState } from "react";

const DashboardFilterBar = ({
  searchTerm,
  setSearchTerm,
  selectedType,
  setSelectedType,
  selectedStatus,
  setSelectedStatus,
  selectedYear,
  setSelectedYear,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  availableTypes,
  onClear,
  onExport,
  onCustomExport,
}) => {
  const [showExport, setShowExport] = useState(false);
  const [showCustomExport, setShowCustomExport] = useState(false);
  const exportRef = useRef(null);
  const customExportRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const yearOptions = [
    currentYear + 1,
    currentYear,
    currentYear - 1,
    currentYear - 2,
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        setShowExport(false);
      }
      if (
        customExportRef.current &&
        !customExportRef.current.contains(event.target)
      ) {
        setShowCustomExport(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formatDate = (date) => (date ? date.toISOString().split("T")[0] : "");

  const baseInputStyle =
    "h-10 border rounded-md px-3 text-sm focus:ring-2 focus:outline-none transition-colors duration-200 " +
    "border-gray-300 text-gray-800 bg-white " +
    "dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:placeholder-gray-400 " +
    "focus:ring-indigo-400 dark:focus:ring-indigo-500";

  const baseButtonStyle =
    "h-10 px-4 rounded-md text-sm font-medium transition-colors duration-200";

  return (
    <div className="flex flex-wrap items-end gap-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-sm rounded-lg p-4 mb-4 transition-colors duration-300">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className={baseInputStyle}
      />

      <select
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className={baseInputStyle}
      >
        <option value="">All Types</option>
        {availableTypes.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </select>

      <select
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
        className={baseInputStyle}
        aria-label="Document year"
      >
        {yearOptions.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <select
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
        className={baseInputStyle}
      >
        <option value="">All Statuses</option>
        <option value="Approved">Approved</option>
        <option value="Pending">Pending</option>
        <option value="Rejected">Rejected</option>
        <option value="Canceled">Canceled</option>
      </select>

      <input
        type="date"
        value={formatDate(startDate)}
        onChange={(e) =>
          setStartDate(e.target.value ? new Date(e.target.value) : null)
        }
        className={baseInputStyle}
      />

      <input
        type="date"
        value={formatDate(endDate)}
        onChange={(e) =>
          setEndDate(e.target.value ? new Date(e.target.value) : null)
        }
        className={baseInputStyle}
      />

      <button
        onClick={onClear}
        className={`${baseButtonStyle} bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100`}
      >
        Clear
      </button>

      <div className="relative" ref={customExportRef}>
        <button
          onClick={() => setShowCustomExport((prev) => !prev)}
          className={`${baseButtonStyle} bg-orange-500 hover:bg-orange-600 text-white`}
        >
          Export Detail to BA ▾
        </button>
        {showCustomExport && (
          <ul className="absolute right-0 mt-2 w-48 z-50 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5">
            <li
              onClick={() => {
                onCustomExport("xlsx");
                setShowCustomExport(false);
              }}
              className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-orange-100 dark:hover:bg-orange-900/40 hover:text-orange-700 dark:hover:text-orange-300 cursor-pointer"
            >
              Excel (.xlsx)
            </li>
            <li
              onClick={() => {
                onCustomExport("csv");
                setShowCustomExport(false);
              }}
              className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-orange-100 dark:hover:bg-orange-900/40 hover:text-orange-700 dark:hover:text-orange-300 cursor-pointer"
            >
              CSV (.csv)
            </li>
          </ul>
        )}
      </div>

      <div className="relative" ref={exportRef}>
        <button
          onClick={() => setShowExport((prev) => !prev)}
          className={`${baseButtonStyle} bg-blue-500 hover:bg-blue-600 text-white`}
        >
          Export File ▾
        </button>
        {showExport && (
          <ul className="absolute right-0 mt-2 w-48 z-50 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5">
            <li
              onClick={() => {
                onExport("xlsx");
                setShowExport(false);
              }}
              className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-blue-100 dark:hover:bg-blue-900/40 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer"
            >
              Excel (.xlsx)
            </li>
            <li
              onClick={() => {
                onExport("csv");
                setShowExport(false);
              }}
              className="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-blue-100 dark:hover:bg-blue-900/40 hover:text-blue-700 dark:hover:text-blue-300 cursor-pointer"
            >
              CSV (.csv)
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default DashboardFilterBar;
